export enum FundSort {
  MostProfit = 'annualEfficiency',
  LeastPrice = 'purchaseNav',
  LeastRisk = 'riskLevel',
  Default = 'displayOrder',
}
